import { render, staticRenderFns } from "./SettingsLocationDetails.vue?vue&type=template&id=07d9b48b&scoped=true&"
import script from "./SettingsLocationDetails.vue?vue&type=script&lang=ts&"
export * from "./SettingsLocationDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d9b48b",
  null
  
)

export default component.exports